import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smart-error",
  "use": "smart-error-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"smart-error\"><g transform=\"translate(1 1)\" stroke=\"#DB0000\" fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FEE\" cx=\"7.5\" cy=\"7.5\" r=\"8\" /><path d=\"M4.5 4.5l6 6M10.5 4.5l-6 6\" stroke-width=\"1.5\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id